var _title, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  x: 0,
  y: 0,
  viewBox: "0 0 115 33",
  style: {
    enableBackground: "new 0 0 115 33"
  },
  xmlSpace: "preserve"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Logo Gemeente Amsterdam Data Amsterdam, naar home")), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0,.st1{fill:#ec0000}.st1{fill-rule:evenodd;clip-rule:evenodd}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -.063)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.853)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M13 5.9H8v1.9h2.7v3.3c-.8.3-1.6.5-2.6.5-2.9 0-4.6-2-4.6-4.8C3.5 4.1 5.3 2 8 2c1.4 0 2.7.6 3.3 1.3L13 1.6C12 .6 10.1 0 8 0 4 0 1 2.6 1 6.8c0 4.1 2.9 6.9 7.1 6.9 2 0 3.6-.4 4.9-1V5.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M17.4 8.1c.1-1.2 1.1-2.1 2.4-2.1 1.4 0 2.1 1 2.1 2.1h-4.5zm6.7 1c0-3.2-1.8-4.8-4.3-4.8-2.7 0-4.7 1.9-4.7 4.7 0 2.9 2 4.6 4.7 4.6 1.7 0 2.9-.6 3.8-1.8l-1.5-1.2c-.5.7-1.2 1.1-2.3 1.1-1.3 0-2.4-.9-2.5-2.2H24c.1-.1.1-.2.1-.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M36.8 4.3c-1.3 0-2.3.6-2.9 1.7-.5-1-1.4-1.7-2.8-1.7s-2.4.8-2.7 1.7V4.5h-2.1v8.8h2.2V8.5c0-1.2.6-2.4 1.9-2.4 1.1 0 1.6.8 1.6 1.9v5.3h2.2V8.5c0-1.1.6-2.4 2-2.4s1.7 1.3 1.7 2.4v4.9h2.2V7.8c0-1.8-1-3.5-3.3-3.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M44.3 8.1c.1-1.2 1.1-2.1 2.4-2.1 1.4 0 2.1 1 2.1 2.1h-4.5zm6.8 1c0-3.2-1.8-4.8-4.3-4.8-2.7 0-4.7 1.9-4.7 4.7 0 2.9 2 4.6 4.7 4.6 1.7 0 2.9-.6 3.8-1.8l-1.5-1.2c-.5.7-1.2 1.1-2.3 1.1-1.3 0-2.4-.9-2.5-2.2H51c.1-.1.1-.2.1-.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M54.9 8.1c.1-1.3 1.1-2.2 2.4-2.2 1.4 0 2.1 1 2.1 2.1h-4.5zm6.7 1c0-3.2-1.8-4.8-4.3-4.8-2.7 0-4.7 1.9-4.7 4.7 0 2.9 2 4.6 4.7 4.6 1.7 0 2.9-.6 3.8-1.8l-1.5-1.2c-.5.7-1.2 1.1-2.3 1.1-1.3 0-2.4-.9-2.5-2.2h6.7c.1-.1.1-.2.1-.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M63.8 13.4H66V8.5c0-1.2.7-2.4 2.1-2.4 1.4 0 1.7 1.3 1.7 2.4v4.9H72V7.8c0-1.8-1-3.6-3.3-3.6-1.3 0-2.4.8-2.7 1.7V4.5h-2.1v8.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M74.8 6.3v4.1c0 1.7.5 3.1 2.9 3.1.5 0 1.1-.1 1.5-.2l-.2-1.7c-.3.1-.6.2-.9.2-1 0-1.2-.6-1.2-1.4V6.3h2.2V4.5h-2.2V2h-2.2v2.6h-1.5v1.8h1.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M82.4 8.1c.1-1.2 1.1-2.1 2.4-2.1 1.4 0 2.1 1 2.1 2.1h-4.5zm6.8 1c0-3.2-1.8-4.8-4.3-4.8-2.7 0-4.7 1.9-4.7 4.7 0 2.9 2 4.6 4.7 4.6 1.7 0 2.9-.6 3.8-1.8l-1.5-1.2c-.5.7-1.2 1.1-2.3 1.1-1.3 0-2.4-.9-2.5-2.2h6.7c.1-.1.1-.2.1-.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0 32.6h2.6l1.2-3h5.6l1.2 3h2.6l-5.6-13h-2L0 32.6zm4.6-4.9 2-5.3 2 5.3h-4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M25 23.5c-1.3 0-2.3.6-2.9 1.7-.5-1-1.4-1.7-2.8-1.7s-2.4.8-2.7 1.7v-1.4h-2.1v8.8h2.2v-4.9c0-1.2.6-2.4 1.9-2.4 1.1 0 1.6.8 1.6 1.9v5.3h2.2v-4.8c0-1.1.6-2.4 2-2.4s1.7 1.3 1.7 2.4v4.9h2.2v-5.5c0-1.8-1-3.6-3.3-3.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M37.1 24.9c-.7-.9-2-1.3-3.3-1.3-1.7 0-3.5.8-3.5 2.8 0 1.7 1.3 2.2 2.6 2.5 1.3.3 2 .5 2 1.3s-.8 1-1.4 1c-1 0-1.8-.5-2.3-1.1l-1.5 1.4c.8.9 2.3 1.5 3.6 1.5 1.9 0 3.7-.8 3.7-2.9 0-1.7-1.5-2.3-2.9-2.6-1.2-.3-1.9-.5-1.9-1.2s.7-1 1.4-1c.8 0 1.5.4 1.9 1l1.6-1.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M39.3 25.6v4.1c0 1.7.5 3.1 2.9 3.1.5 0 1.1-.1 1.5-.2l-.1-1.7c-.3.1-.7.1-1 .1-1 0-1.2-.6-1.2-1.4v-4.1h2.2v-1.8h-2.2v-2.6h-2.2v2.6h-1.5v1.8h1.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M47 27.3c.1-1.2 1.1-2.1 2.4-2.1 1.4 0 2.1 1 2.1 2.1H47zm6.7 1c0-3.2-1.8-4.8-4.3-4.8-2.7 0-4.7 1.9-4.7 4.7 0 2.9 2 4.6 4.7 4.6 1.7 0 2.9-.6 3.8-1.8l-1.4-1c-.5.7-1.2 1.1-2.3 1.1-1.3 0-2.4-.9-2.5-2.2h6.7v-.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M55.8 32.6H58v-4.7c0-.6.4-2.4 2.4-2.4.2 0 .4 0 .7.1v-2c-.1 0-.4-.1-.5-.1-1.2 0-2.1.7-2.6 1.7v-1.5h-2.1v8.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M71.2 18.7H69v6.2h-.1c-.5-.6-1.3-1.4-3-1.4-2.5 0-4.3 2-4.3 4.6 0 2.6 1.7 4.7 4.3 4.7 1.2 0 2.4-.6 3-1.6v1.3H71V18.7zm-7.3 9.5c0-1.4.8-2.8 2.5-2.8 1.6 0 2.6 1.5 2.6 2.9s-1 2.8-2.6 2.8c-1.7 0-2.5-1.5-2.5-2.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M79.4 32.6h2.1v-5.4c0-1.8-.8-3.7-3.9-3.7-1.3 0-2.7.5-3.7 1.4l1.1 1.3c.6-.6 1.5-1 2.4-1 1.1 0 2 .5 2 1.6v.2c-2.8 0-6.1.4-6.1 3 0 2.1 1.9 2.7 3.3 2.7 1.3 0 2.3-.6 2.7-1.3h.1v1.2zm-.1-3.7c0 1.4-.8 2.3-2.3 2.3-.8 0-1.5-.3-1.5-1.1 0-1.3 2-1.5 3.4-1.5h.5v.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M94.5 23.5c-1.3 0-2.3.6-2.9 1.7-.5-1-1.4-1.7-2.8-1.7s-2.4.8-2.7 1.7v-1.4H84v8.8h2.2v-4.9c0-1.2.6-2.4 1.9-2.4 1.1 0 1.6.8 1.6 1.9v5.3H92v-4.8c0-1.1.6-2.4 2-2.4s1.7 1.3 1.7 2.4v4.9h2.2v-5.5c-.1-1.8-1.1-3.6-3.4-3.6z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .082)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "m0 31.1 3-3-3-2.9 2-1.9 3 2.9 3-2.9 2 1.9-3 2.9 3 3L8 33l-3-2.9L2 33z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "m0 7.8 3-2.9-3-3L2 0l3 2.9L8 0l2 1.9-3 3 3 2.9-2 1.9-3-2.9-3 2.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "m0 19.4 3-2.9-3-2.9 2-1.9 3 2.9 3-2.9 2 1.9-3 2.9 3 2.9-2 2-3-3-3 3z"
})))));
export default SvgLogo;